// authUtils.ts
import Cookies from "js-cookie";
import { getDefaultStore } from "jotai";
import { userDataAtom } from "../store/userStore";

/**
 * Check if the current environment is local/development
 * @returns boolean indicating if running in local/development environment
 */
export const isLocalEnvironment = (): boolean => {
  // Check if window is available (not in worker or SSR context)
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === "development" || process.env.REACT_ENV === "local";
  }
  
  return (
    process.env.NODE_ENV === "development" ||
    process.env.REACT_ENV === "local"
  );
};

/**
 * Get authentication token based on environment
 * @returns string | null - auth token for current environment
 */
export const getAuthToken = (): string | null => {
  const token = Cookies.get("SPAExtensionSSO") || null;
  return token;
};

/**
 * Get user ID based on environment
 * @returns string | null - user ID for current environment
 */
export const getUserId = (): string | null => {
  try {
    const store = getDefaultStore();
    const userData = store.get(userDataAtom);
    const userId = userData?.id || null;
    return userId;
  } catch (error) {
    // Fallback if store is not available (e.g., in worker context)
    return process.env.REACT_APP_USER_ID || null;
  }
};

/**
 * Get upload configuration with environment-specific auth token and user ID
 * @returns object with authToken and userId
 */
export const getUploadConfig = (): { authToken: string | null; userId: string | null } => {
  return {
    authToken: getAuthToken(),
    userId: getUserId(),
  };
};